module.exports = __webpack_public_path__ + "img/cases-brand-herborist-lazyload-91.68a742fa.jpg";